import { RegItem } from 'src/types/regItem'
import { NavLink, RightDrawer } from 'baby-design'
import { useEffect } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import ProductInfoDrawerFields from 'src/routes/(registry)/list/[slug]/components/ProductInfoDrawer/components/ProductInfoDrawerFields/ProductInfoDrawerFields'
import useSaveRegItem from '../../hooks/useSaveRegItem'

interface ProductInfoDrawerProps {
  regItem: RegItem
}

export default NiceModal.create(({ regItem }: ProductInfoDrawerProps) => {
  const modal = useModal()
  const {
    saveRegItemMutation,
    onSave,
    regItemChanges,
    setRegItemChanges,
    handleClose,
    hasUnsavedChanges,
  } = useSaveRegItem({ regItem, modal })

  useEffect(() => {
    setRegItemChanges({})
  }, [modal.visible])

  const updateRegItemChanges = (fields: object) => {
    setRegItemChanges({ ...regItemChanges, ...fields })
  }

  const regItemFields = { ...regItem, ...regItemChanges }

  const showPrice =
    !regItem.isExternalRegistry &&
    !regItem.isFavor &&
    !regItem.isGiftCard &&
    !regItem.isCrowdfund

  const allowImageEdit = !regItem.isGroupGift

  return (
    <RightDrawer
      contextualIcon={
        <NavLink
          disabled={saveRegItemMutation.isLoading || !hasUnsavedChanges()}
          size="md"
          variant="eggplant"
          onClick={onSave}
        >
          Save
        </NavLink>
      }
      handleClose={handleClose}
      handleDismount={modal.remove}
      isOpen={modal.visible}
      mainIcon="back"
      title="Product Info"
    >
      <ProductInfoDrawerFields
        allowImageEdit={allowImageEdit}
        isPriceEditable={regItem.isPriceEditable}
        isTitleEditable={regItem.isTitleEditable}
        regItemFields={regItemFields}
        showPrice={showPrice}
        onUpdateRegItemFields={updateRegItemChanges}
      />
    </RightDrawer>
  )
})
